var arrayToMap=function(r,e){return r.reduce(function(r,a){return r[a[e]]=a,r},{})};export default arrayToMap;
